import {
  Box,
  FormControlLabel,
  FormHelperText,
  Grid,
  InputAdornment,
  InputLabel,
  Radio,
  RadioGroup,
  Stack,
  Typography,
} from "@mui/material";
import { useContext } from "react";
import { CustomInput } from "global/components";
import { ContactContext } from "../Context";
import { useTheme } from "@mui/material/styles";
import { isTruthy } from "helpers/methods";
import strings from "global/constants/StringConstants";

const GroupNameTypeSelection = () => {
  const theme = useTheme();
  const { formFields, setFormFields } = useContext(ContactContext);

  const handleOnChange = (event: React.ChangeEvent<any>) => {
    if (event.target.name === "groupType") {
      setFormFields({
        ...formFields,
        [event.target.name]: {
          value: +event.target.value,
          error: "",
        },
      });
    } else {
      if (strings.groupNameRegex.test(event.target.value))
        setFormFields({
          ...formFields,
          [event.target.name]: {
            value: event.target.value,
            error: "",
          },
        });
    }
  };
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <Stack spacing={1}>
            <InputLabel
              sx={{
                fontSize: "1rem",
                color: "#475569",
              }}
              required
            >
              Group Name
            </InputLabel>
            <CustomInput
              required
              id="groupname-input"
              placeHolder="Group name"
              name="groupName"
              onChange={handleOnChange}
              propsToInputElement={{ maxlength: 50 }}
              value={formFields.groupName?.value}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <span style={{ fontSize: "0.75rem" }}>
                      {formFields.groupName?.value.trim().length} / 50
                    </span>
                  </InputAdornment>
                ),
              }}
            />
            {isTruthy(formFields.groupName.error) && (
              <FormHelperText error>
                {formFields.groupName.error}
              </FormHelperText>
            )}
          </Stack>
        </Grid>
      </Grid>

      <Grid container spacing={2} pt={2}>
        <Grid item xs={6} spacing={2}>
          <Stack spacing={1}>
            <InputLabel
              sx={{
                fontSize: "1rem",
                color: "#475569",
              }}
              required
            >
              Group Type
            </InputLabel>
            <RadioGroup
              name="groupType"
              value={formFields.groupType?.value}
              onChange={handleOnChange}
            >
              <Stack gap={1}>
                <FormControlLabel
                  value={0}
                  control={<Radio size="small" sx={{ padding: "5px" }} />}
                  label={
                    <Stack spacing={0.5} ml={0.5}>
                      <Typography
                        variant="subtitle2"
                        sx={{
                          color:
                            formFields.groupType?.value === 0
                              ? theme.palette.primary.main
                              : "#475569",
                          fontWeight: "bold",
                        }}
                      >
                        Private Group
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Contacts added to a private group will be visible only
                        to you and your managers.
                      </Typography>
                    </Stack>
                  }
                />
                <FormControlLabel
                  value={1}
                  control={<Radio size="small" sx={{ padding: "5px" }} />}
                  label={
                    <Stack spacing={0.5} ml={0.5}>
                      <Typography
                        variant="subtitle2"
                        sx={{
                          color:
                            formFields.groupType?.value === 1
                              ? theme.palette.primary.main
                              : "#475569",
                          fontWeight: "bold",
                        }}
                      >
                        Public Group
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Contacts added to a public group will be accessible to
                        everyone under your account.
                      </Typography>
                    </Stack>
                  }
                />
              </Stack>
            </RadioGroup>
          </Stack>
        </Grid>
      </Grid>
    </>
  );
};

export default GroupNameTypeSelection;
